import { recomendedPostsAnalyticsAction } from '../../jsCore/organizedByType/actions/analyticsActions'
import { dispatch } from '../../jsCore/application/appStore'

export function buildLinkUrl(url, index, version) {
  return `${url}?view_source=recommendations&view_medium=inarticle_recommendations&unit_version=${version}&item_position=${index}`
}

export function reportAnalytics(version, index) {
  dispatch(recomendedPostsAnalyticsAction(version, index))
}

export function imageProps(imageSrc, className) {
  return {
    lazyLoad: true,
    src: imageSrc,
    className: className,
    alt: 'image',
  }
}

export function hasPosts(posts) {
  return posts !== undefined && posts !== null && posts.length > 0
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/recommendedPosts/utils.js